import cssGlobal from 'tfs.css-global'
import staticData from '../../config/staticData'

const appStyles = {
  width: '100%',
  paddingBottom: '4rem',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}

export default {
  ...(cssGlobal as {}),
  app: { ...appStyles },
  appLogin: {
    ...appStyles,
    backgroundImage: `url(${staticData.splashScreenUrl})`,
    backgroundSize: 'cover',
  },
  mainNavigation: {
    alignSelf: 'stretch',
    zIndex: 101,
  },
} as const
